export enum enumRoofType {
    Glass = 1,
    Polycarbonate = 2
}